import BigNumber from 'bignumber.js';
import { useEffect, useRef, useState } from 'react';

const PRECISION = BigNumber('100000000'); // 1e8 精度
const THRESHOLD = BigNumber('10000'); // 0.01% = 1e-4 * 1e8 = 10000

export function useStableEntryPrice(
  entryPrice?: BigNumber,
  threshold = THRESHOLD,
) {
  const lastPriceRef = useRef<BigNumber | undefined>(undefined);
  const [stablePrice, setStablePrice] = useState<BigNumber | undefined>(
    entryPrice,
  );

  useEffect(() => {
    if (!entryPrice) return;

    if (!lastPriceRef.current) {
      // 初始化
      lastPriceRef.current = entryPrice;
      setStablePrice(entryPrice);
      
return;
    }

    // 计算 |new - old| / old * 1e8
    const diff = entryPrice.minus(lastPriceRef.current).abs();
    const ratio = diff.times(PRECISION).div(lastPriceRef.current);

    // 当变化大于 threshold 时才更新
    if (ratio.gt(threshold)) {
      lastPriceRef.current = entryPrice;
      setStablePrice(entryPrice);
    }
  }, [entryPrice]);

  return stablePrice;
}
